'use client';

import { useEffect } from 'react';
import { useThemeStore } from '@/utils/util_states';

export default function ThemeInitializer() {
    const initTheme = useThemeStore((state) => state.initTheme);

    useEffect(() => {
        void initTheme();
    }, [initTheme]);

    return null;
}
